import { render, staticRenderFns } from "./VerifyMTACode.vue?vue&type=template&id=0d7e5f62&"
import script from "./VerifyMTACode.vue?vue&type=script&lang=ts&"
export * from "./VerifyMTACode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports